<kf-payjp>
  <script>
    const ON_CREATED_NAME = `__payjpOnCreated_${Math.random() * 1e16}__`;
    const ON_FAILED_NAME = `__payjpOnFailed_${Math.random() * 1e16}__`;

    const opts = {
      apiKey: 'pk_test_fcb9fbfdcdb0558125216a10',
      clientId: 'test_client_id',
      partial: true,
      text: 'Pay with Card',
      submitText: 'Submit Payment',
      tokenName: 'payjp-token',
      previousToken: null,
      lang: 'en',
      namePlaceholder: 'John Doe',
    };

    export default {
      getToken() {
        return document.querySelector('input[name="payjp-token"]') ?
          document.querySelector('input[name="payjp-token"]').value : null;
      },

      onCreated(token) {
        this.props.onTokenCreated?.(token);
      },
      onFailed(error) {
        console.error('Payment failed:', error);
      },

      onMounted() {

        const ON_CREATED_NAME = `__payjpOnCreated_${Math.random() * 1e16}__`;
        const ON_FAILED_NAME = `__payjpOnFailed_${Math.random() * 1e16}__`;
        this.ON_CREATED_NAME = ON_CREATED_NAME;
        this.ON_FAILED_NAME = ON_FAILED_NAME;

        window[ON_CREATED_NAME] = (token) => this.onCreated(token);
        window[ON_FAILED_NAME] = (error) => this.onFailed(error);

        const scriptEl = document.createElement('script');
        // https://pay.jp/docs/checkout
        const attrs = {
          type: 'text/javascript',
          src: 'https://checkout.pay.jp/',
          class: 'payjp-button',
          'data-key': opts.apiKey,
          'data-payjp': opts.clientId,
          'data-partial': !!opts.partial,
          'data-text': opts.text,
          'data-submit-text': opts.submitText,
          'data-token-name': opts.tokenName,
          'data-previous-token': opts.previousToken,
          'data-lang': opts.lang,
          'data-on-created': ON_CREATED_NAME,
          'data-on-failed': ON_FAILED_NAME,
          'data-name-placeholder': opts.namePlaceholder
        };
        for (const key in attrs) {
          if (attrs.hasOwnProperty(key)) {
            const value = attrs[key];
            if (value !== undefined) {
              scriptEl.setAttribute(key, value);
            }
          }
        }
        this.root.appendChild(scriptEl);
      },

      onBeforeUnmount() {
        window[this.ON_CREATED_NAME] = undefined;
        window[this.ON_FAILED_NAME] = undefined;
        window.PayjpCheckout = undefined;
        const payjpEl = document.querySelector('#payjp-checkout-iframe').parentNode;
        payjpEl.parentNode.removeChild(payjpEl);
      },
    };

  </script>
</kf-payjp>
